import { pipe, prop } from 'ramda'
import { Policy } from './types'
import { getBenefitData } from './getBenefitData'

/**
 * V2 version of getBenefitLimitValue() util function. We will want to deprecate
 * all previous versions of getBenefitLimitValue() in both V2 (there is one in
 * this package) and V1. Returns the benefit limit value for a given policy and
 * benefit type
 *
 * @param policy - The policy object containing benefit information
 * @param benefitType - The type of benefit to retrieve the limit for
 * @returns The limit value of the benefit if found, undefined otherwise
 */
export const getBenefitLimit = (
  policy: Policy | null | undefined,
  benefitType: string,
): number | undefined => {
  // Create a type-safe version of the pipe operation
  const getBenefitLimit = pipe(
    // First get the benefit data
    (p: Policy | null | undefined, bt: string) => getBenefitData(p, bt),
    // Then extract the limitValue property, which will be undefined if benefit is undefined
    prop('limitValue'),
  )

  return getBenefitLimit(policy, benefitType)
}
